import { render, staticRenderFns } from "./NoticeTemplateDetailPanel.vue?vue&type=template&id=20a31611&"
import script from "./NoticeTemplateDetailPanel.vue?vue&type=script&lang=js&"
export * from "./NoticeTemplateDetailPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports